import React from 'react';
import BackButton from '@components/common/BackButton/BackButton';
import './ssoIdentityView.less';

export default function SSOIdentityView({email, onBack}) {
    const avatarInitial = (email || '?').charAt(0).toUpperCase();

    return (
        <div className="sso-identity-view">
            <BackButton onClick={onBack} dataWdio="test-sso-back-button" />
            <div className="sso-identity-card">
                <div className="sso-identity-avatar">{avatarInitial}</div>
                <span className="sso-identity-email">{email}</span>
            </div>
        </div>
    );
}
